import { AuthService } from 'src/app/services/auth.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: false
})
export class UnauthorizedComponent implements OnInit, OnDestroy {
    public isUserAuthenticated = false;
    private destroy$ = new Subject<void>();

    constructor(private authService: AuthService) {
        this.authService.user$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.isUserAuthenticated = this.authService.isLoggedIn();
            });
    }

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public login = () => {
        this.authService.startAuthentication();
    }

    public logout = () => {
        this.authService.logout();
    }
}
